import React, { Component } from 'react'
import { DropDown } from './common';
import { validatable } from 'components/utils';

class DropDownSort extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: []
    }
  }

  componentDidMount() {
    let sortData = [];
    let ngayTiepDanGiamDan = {
      ten: 'Ngày tiếp dân - giảm dần',
      value: 'ngayTiepDan,desc'
    };
    let ngayTiepDanTangDan = {
      ten: 'Ngày tiếp dân - tăng dần',
      value: 'ngayTiepDan,asc'
    };
    let ngayTiepNhanGiamDan = {
      ten: 'Ngày tiếp nhận - giảm dần',
      value: 'ngayTiepNhan,desc'
    };
    let ngayTiepNhanTangDan = {
      ten: 'Ngày tiếp nhận - tăng dần',
      value: 'ngayTiepNhan,asc'
    };
    let ngaySuaGiamDan = {
      ten: 'Ngày sửa - giảm dần',
      value: 'ngaySua,desc'
    };
    let ngaySuaTangDan = {
      ten: 'Ngày sửa - tăng dần',
      value: 'ngaySua,asc'
    };
    let ngayLapDonGapLanhDaoGiamDan = {
      ten: 'Ngày đăng kí gặp lãnh đạo - giảm dần',
      value: 'ngayLapDonGapLanhDaoTmp,desc'
    };
    let ngayLapDonGapLanhDaoTangDan = {
      ten: 'Ngày đăng kí gặp lãnh đạo - tăng dần',
      value: 'ngayLapDonGapLanhDaoTmp,asc'
    };
    let sortItem1 = [
      ngayTiepDanTangDan,
      ngayTiepDanGiamDan,
      ngaySuaTangDan,
      ngaySuaGiamDan
    ];
    let sortItem2 = [
      ngayLapDonGapLanhDaoTangDan,
      ngayLapDonGapLanhDaoGiamDan,
      ngaySuaTangDan,
      ngaySuaGiamDan
    ];
    let sortItem3 = [
      ngayTiepNhanTangDan,
      ngayTiepNhanGiamDan,
      ngaySuaTangDan,
      ngaySuaGiamDan
    ];
    if (this.props.type === 'tiepCongDanThuongXuyen' || this.props.type === 'soTiepDinhKy' || this.props.type === 'soTiepDotXuat') {
      sortData.push(...sortItem1);
    }
    if (this.props.type === 'dangKiGapLanhDao') {
      sortData.push(...sortItem2);
    }
    if (this.props.type === 'soXuLyDon' || this.props.type === 'giaiQuyetDon' || this.props.type === 'theoDoiThucHien' || this.props.type === 'donDaGiaiQuyet') {
      sortData.push(...sortItem3);
    }
    this.setState({
      data: sortData
    });
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown
        bindValidator={this}
        channel="formSort"
        isValid={this.props.isValid}
        require={this.props.require}
        label={this.props.label}
        className={this.props.className}
        keyName='value'
        valueName='ten'
        options={this.state.data}
        onChange={this.onChange.bind(this)}
        placeholder={this.props.placeholder}
        selectedValue={this.props.selectedValue}
        name={this.props.name}/>
    )
  }
}

DropDownSort.defaultProps = {
  label: 'Sắp xếp theo:',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  name:''
}

export default validatable(DropDownSort);


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-sort.jsx